const examples = () => {
  const addEvent = () => {
    $("body").on("mouseenter", "span.style-trigger", (e) => {
      $(e.target).trigger("click");
    });
    $("body").on("mouseleave", "span.style-trigger", (e) => {
      $(e.target).trigger("click");
    });
  };
  addEvent();
};
// DOMの読み込み完了後に実行する
document.addEventListener("DOMContentLoaded", examples);
